import { Loader2 } from 'lucide-react';
import { isLyrraOne } from '@/lib/platform';
import { useLyrraOnePlan } from '@/hooks/useLyrraOnePlan';
import type { LyrraOnePlanFeature } from '@/lib/lyrraone-plan';
import { LyrraOnePlanUpgradeCard } from '@/components/lyrraone/LyrraOnePlanUpgradeCard';
import { LyrraOneGate, lyrraOneMarketingShellClass } from '@/components/lyrraone/LyrraOneModulePage';

type LyrraOnePlanFeatureGateProps = {
  feature: LyrraOnePlanFeature;
  children: React.ReactNode;
  /** Contenu affiché si la fonctionnalité n'est pas incluse dans le plan. */
  fallback?: React.ReactNode;
  title?: string;
  description?: string;
};

export function LyrraOnePlanFeatureGate({
  feature,
  children,
  fallback,
  title,
  description,
}: LyrraOnePlanFeatureGateProps) {
  if (!isLyrraOne()) return <>{children}</>;

  return (
    <LyrraOneGate>
      <LyrraOnePlanFeatureGateInner
        feature={feature}
        fallback={fallback}
        title={title}
        description={description}
      >
        {children}
      </LyrraOnePlanFeatureGateInner>
    </LyrraOneGate>
  );
}

function LyrraOnePlanFeatureGateInner({
  feature,
  children,
  fallback,
  title,
  description,
}: LyrraOnePlanFeatureGateProps) {
  const { loading, hasFeature } = useLyrraOnePlan();

  if (loading) {
    return (
      <div className={`${lyrraOneMarketingShellClass} flex justify-center py-16`}>
        <Loader2 className="h-8 w-8 animate-spin" style={{ color: 'var(--lo-blue)' }} aria-hidden />
      </div>
    );
  }

  if (!hasFeature(feature)) {
    return (
      <div className={`${lyrraOneMarketingShellClass} py-8`}>
        {fallback ?? (
          <LyrraOnePlanUpgradeCard feature={feature} title={title} description={description} />
        )}
      </div>
    );
  }

  return <>{children}</>;
}
